import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-claro-icon-mat-icon',
  templateUrl: './claro-icon-mat-icon.component.html',
  styleUrls: ['./claro-icon-mat-icon.component.scss']
})
export class ClaroIconMatIconComponent implements OnInit {
  @Input() iconName : string;
  @Input() colorScheme : string;
  @Input() size: string;
  @Input() fontSize: string;
  @Input() lineHeight: string;
  constructor() { }

  ngOnInit(): void {
  }

}
